import Callback from "pages/LandingPages/SignIn/callback";

export default function CallbackPage() {
  return <Callback />;
}
